import {
  ACTIVATE_USER,
  CLEAR_AUTH,
  FORGET_PASS_INPUT,
  GET_BRANCH,
  GLOBAL_LOADING,
  GLOBAL_LOADING_DONE,
  HIDE_APPLICATION_SUGGEST,
  LOADING_MUTATIONS,
  LOADING_MUTATIONS_DONE,
  LOGIN,
  LOGOUT,
  SET_CODE_INPUT,
  SHOW_ALERT,
  SHOW_APPLICATION_SUGGEST,
  SHOW_NOTIFICATIONS,
  TWO_STEP_LOGIN,
  USER_LOADED,
  VERIFY_TFA,
} from 'redux/actions/types';
import jwt from 'jwt-decode';
import { Data } from 'iconsax-react';

const initialState = {
  userData: {
    id: null,
    firstNameFa: null,
    lastNameFa: null,
    isActive: null,
    files: null,
    status: {},
  },
  twoStepLogin: false,
  forgetPassCodeInput: { step: 0 },
  isAuthenticated: null,
  isBranch: true,
  mutationLoading: null,
  globalLoading: false,
  showSuggest: false,
  showAlert: {
    message: '',
    bool: false,
  },
};

const authReducer = (state = initialState, { type, res }) => {
  switch (type) {
    case LOGIN:
      if (res.login.token) {
        const user = jwt(res.login.token);
        localStorage.setItem('token', res.login.token);
        return {
          ...state,
          isAuthenticated: true,
          isBranch: user.isBranch,

          showAlert: {
            ...state.showAlert,
            bool: false,
          },
        };
      }

    case ACTIVATE_USER:
      if (res?.activateUser?.token) {
        localStorage.setItem('token', res.activateUser?.token);
        return {
          ...state,
          userData: {
            ...state.userData,
          },
          isAuthenticated: true,
        };
      }

    case LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    case GET_BRANCH:
      return {
        ...state,
        branch: res.branch,
      };
    case USER_LOADED:
      const token = localStorage.getItem('token');
      const { isBranch } = jwt(token);
      const {
        id,
        firstNameFa,
        lastNameFa,
        isActive,
        merchantType,
        comNameFa,
        files,
        instantSettlementAccess,
        status,
        trusted,
        permissionForApi,
        hasBranch,
        authentications,
        commissionBack,
        accounts,
        terminals,
      } = res.user;
      return {
        ...state,
        isBranch,
        userData: {
          ...state.userData,
          id,
          firstNameFa,
          lastNameFa,
          merchantType,
          comNameFa,
          isActive,
          trusted,
          permissionForApi,
          hasBranch,
          instantSettlementAccess,
          status,
          files,
          authentications,
          commissionBack,
          accounts,
          terminals,
        },
        loading: false,
        isAuthenticated: true,
      };
    case SHOW_ALERT:
      return {
        ...state,
        showAlert: {
          message: res,
          bool: true,
        },
      };
    case SET_CODE_INPUT:
      return {
        ...state,
        codeInput: true,
        mobileNumber: res.mobile,
      };
    case FORGET_PASS_INPUT:
      return {
        ...state,
        forgetPassCodeInput: res,
      };
    case SHOW_NOTIFICATIONS:
      return {
        ...state,
        showNotifications: res,
      };
    case LOADING_MUTATIONS:
      return {
        ...state,
        mutationLoading: true,
      };
    case LOADING_MUTATIONS_DONE:
      return {
        ...state,
        mutationLoading: false,
      };
    case TWO_STEP_LOGIN:
      return {
        ...state,
        twoStepLogin: true,
        loginMessage: res?.login?.message,
      };
    case VERIFY_TFA:
      localStorage.setItem('token', res.verifyTFA.token);
      return {
        ...state,
        isAuthenticated: true,

        showAlert: {
          ...state.showAlert,
          bool: false,
        },
      };
    case GLOBAL_LOADING:
      return {
        ...state,
        globalLoading: true,
      };
    case GLOBAL_LOADING_DONE:
      return {
        ...state,
        globalLoading: false,
      };
    case SHOW_APPLICATION_SUGGEST:
      return {
        ...state,
        showSuggest: true,
      };
    case HIDE_APPLICATION_SUGGEST:
      return {
        ...state,
        showSuggest: false,
      };
    case CLEAR_AUTH:
      return initialState;

    default:
      return state;
  }
};

export default authReducer;
